import { RadioGroup } from "@headlessui/react";
import React from "react";
import classNames from "src/helpers/classNames";
import { ValueWithStock } from "src/helpers/inventory-helpers/getOptionValuesWithStock";
import Absorptions from "src/components/absorptions/Absorptions";
import { useTranslations } from "next-intl";
import spaceToUnderscore from "src/helpers/strings/spaceToUnderscore";
import AbsorptionExplanation from "./AbsorptionExplanation";
import { useMediaQuery } from "usehooks-ts";

type NewAbsorptionsSelectProps = {
  selectedAbsorption: string | null;
  setSelectedAbsorption(color: string): void;
  valuesWithStock: ValueWithStock[];
  stickyFooter: boolean;
};

function NewAbsorptionsSelect({
  valuesWithStock,
  selectedAbsorption,
  setSelectedAbsorption,
  stickyFooter,
}: NewAbsorptionsSelectProps) {
  const t = useTranslations("ProductOverview");

  const mobileAddToCartBreakpointReached = useMediaQuery("765");

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="font-bold">{t("absorption")}</h2>
      </div>

      <RadioGroup
        value={selectedAbsorption}
        onChange={setSelectedAbsorption}
        className="mt-2"
      >
        <RadioGroup.Label className="sr-only" role="radio">
          Choose an absorption level
        </RadioGroup.Label>
        <div className="flex">
          {valuesWithStock.map(({ value, stock }, index) => (
            <RadioGroup.Option
              key={value}
              value={value}
              className={({ active, checked }) =>
                classNames(
                  stock > 0
                    ? "cursor-pointer focus:outline-none"
                    : "cursor-default opacity-25",
                  index !== 0 ? "ms-3" : "",
                  checked || active ? "ring-2 ring-offset-2" : "",
                  checked ? "" : "hover:bg-gray-50",
                  "mb-2 min-w-[7rem] max-w-[50%] flex-1 rounded-sm border border-gray-200 px-1.5 py-2 text-sm font-medium uppercase ring-gray-700 xl:px-3"
                )
              }
              disabled={stock === 0}
            >
              <RadioGroup.Label as="div" className="flex flex-col items-center">
                <Absorptions value={value} imageClassName="w-3" />
                <span className="mt-1">{t(spaceToUnderscore(value))}</span>
              </RadioGroup.Label>
            </RadioGroup.Option>
          ))}
        </div>
      </RadioGroup>
      {!stickyFooter && (
        <AbsorptionExplanation selectedAbsorption={selectedAbsorption} />
      )}
    </div>
  );
}

export default NewAbsorptionsSelect;
